/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-08 11:31:58                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-11 10:05:40                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Styles
  * CardHead: dashboard card head
*/

/* Import */
import { t } from "i18next";
import { Button, Card, Typography } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
/***/

/* Styles */
import "./DashboardCardLayout.scss";
/***/

/**
* CardLayout: dashboard card layout
* display common informations
*/
export default function DashboardCardLayout({
  children,
  title,
  path,
  current,
  max
}: {
  children: React.ReactNode,
  title: string,
  path?: string,
  current?: number,
  max?: number
}) {
  const navigate = useNavigate();

  return (
    <div className="dashboard-card-layout">
      <div className="dashboard-card-head">
        <Typography>
          {title}
        </Typography>
      </div>

      <Card className="dashboard-card-content">
        {children}
      </Card>

      <Button variant="outlined"
              className="view-all-button"
              onClick={() => navigate(path || "#")}>
        {t("common:viewAll")}
      </Button>
    </div>
  );
}
/***/
